import { SagaIterator } from "redux-saga";
import {
  all,
  call,
  debounce,
  fork,
  put,
  select,
  takeEvery,
} from "redux-saga/effects";

import {
  fetchDataFailure,
  fetchDataRequest,
  fetchDataSuccess,
} from "./actions";
import offeringService from "../../services/api/offering";
import {
  FETCH_TRIGGER,
  FILTER_RESET,
  FILTER_TEXT_UPDATE,
  FILTER_UPDATE,
  PAGINATION_UPDATE,
  SORT_UPDATE,
} from "./constants";
import { METADATA_UPDATE } from "../metadata/constants";
import { selectPayload } from "./selectors";

export function* getSearchResults(): SagaIterator {
  try {
    yield put(fetchDataRequest());

    const params = yield select(selectPayload);
    const data = yield call([offeringService, offeringService.getAll], params);
    const pages = Math.ceil(data.paging.total_items / params.limit);

    yield put(fetchDataSuccess({ data: data.items, pages }));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

export function* watchGetSearchResults(): SagaIterator {
  yield takeEvery(
    [
      FETCH_TRIGGER,
      PAGINATION_UPDATE,
      SORT_UPDATE,
      FILTER_UPDATE,
      FILTER_RESET,
      METADATA_UPDATE,
    ],
    getSearchResults,
  );
}

export function* debounceSearch(): SagaIterator {
  yield debounce(
    500,
    (action: any) => {
      return action.type === FILTER_TEXT_UPDATE && action.payload.valid;
    },
    getSearchResults,
  );
}

export function* offeringsSaga(): SagaIterator {
  yield all([fork(watchGetSearchResults), fork(debounceSearch)]);
}
